export default "__VITE_ASSET__BDbp8DFn__"